export default {
  login: {
    new_user: {
      text: "Don't have an account?",
      link: 'Sign Up'
    },
    title: 'Welcome Back!',
    // description:
    //   'Sign in to accelerate user adoption by creating professional product training videos in minutes.',
    description: 'Sign in to accelerate user adoption',
    google: 'Sign in with Google',
    login_with_email: 'Login',
    continue_with_email: 'Continue with your email',
    forgot_password: 'Forgot password?',
    terms: 'By logging in you agree to our terms and conditions'
  },
  register: {
    existing_user: {
      text: 'Already have an account?',
      link: 'Log In'
    },
    user_exists:
      'You already have an account associated with this email id. Kindly login to continue.',
    title: 'Welcome to Trainn!',
    change: 'Change',
    // description:
    //   'Sign up to accelerate user adoption by creating professional product training videos in minutes.',
    description: 'Sign up to accelerate user adoption',
    google: 'Sign up with Google',
    email_sign_up: {
      email: 'Email',
      email_placeholder: 'john@yoda.io',
      password: 'Password',
      confirm_password: 'Confirm password',
      otp: 'One time password',
      otp_placeholder: 'Enter one time password',
      otp_desc: 'OTP is valid for 5 minutes',
      send_otp: 'Send OTP',
      continue_with_email: 'Continue with email',
      resend_otp: 'Resend otp',
      otp_sent: 'OTP has been sent to your mail',
      reset_password: 'Your password has been reset. Kindly login to continue!',
      verify_otp: 'Verify and Proceed',
      set_password: 'Set Password',
      password_title: 'Setup your password',
      create_account: 'Create account',
      user_exists: 'User already exists. Please try logging in.',
      reset_password_desc:
        'One time password will be sent to the given email address',
      reset_password_title: 'Reset password',
      set_password_title: 'Set your password',
      verify_otp_desc: 'Verify your email address',
      verify_otp_cta_reset: 'Verify & Reset password',
      verify_otp_cta_set: 'Verify & Set password',
      verify_otp_cta_signup: 'Verify & Continue',
      set_password_cta_reset: 'Reset & Login',
      set_password_cta_set: 'Update & Login',
      set_password_cta_signup: 'Set & Continue',
      reset_password_veriy_otp_desc:
        'We have sent an one time password(OTP) to your email address. Please verify it to reset your password.',
      set_password_veriy_otp_desc:
        'We have sent an one time password(OTP) to your email address. Please verify it to set your password.',
      set_password_veriy_otp_signup_desc:
        'We have sent an one time password(OTP) to your email address. Please verify it to create an account with us.',
      passowrd_description:
        // 'Your password should have atleast one upper case character, one lower case character, one special character, one number and should have minimum 8 characters'
        'Your password must be at least 8 characters long with a minimum of one uppercase, one number and one special character.'
    },
    terms: 'By signing up you agree to our terms and conditions',
    profile: {
      title: 'Profile',
      description: 'Tell us a bit about yourself',
      name: 'Full Name',
      placeholder: 'John Doe',
      cta: 'Set & Continue'
    },
    workspace: {
      theme: {
        title: 'Theme',
        description: 'For a more personalised experience',
        input: {
          label: 'Enter a name for your product space',
          display_label: 'Workspace display name',
          placeholder: 'Yoda',
          error: 'Please enter a product space name',
          min_length_error:
            'Workspace name should have a minimum of 4 characters'
        },
        brand: {
          label: 'Brand color',
          hex_label: 'Or hex'
        },
        logo: {
          label: 'Company Logo'
        },
        note: 'You can change these values later in the settings section'
      }
    },
    extension: {
      title: 'Install Extension',
      description:
        'Almost done! Download our chrome extension and record your first workflow right away!',
      btn: 'Install Extension',
      skip: 'I will install later'
    },
    btn: {
      proceed: 'Proceed',
      update: 'Update'
    }
  }
};
